<ng-template [sbmodal]="'trackerAssignment'">
  <sb-custom-modal [templateId]="'trackerAssignment'">
    <div slot="body">
      <sb-comp-location-tracker-assignment-to-screens
        [isInModalContext]="'trackerAssignment'"></sb-comp-location-tracker-assignment-to-screens>
    </div>
  </sb-custom-modal>
</ng-template>

<ng-template [sbmodal]="'screenAssignment'">
  <sb-custom-modal [templateId]="'screenAssignment'">
    <div slot="body">
      <sb-comp-location-tracker-assignment-to-tracker
        [isInModalContext]="'screenAssignment'"></sb-comp-location-tracker-assignment-to-tracker>
    </div>
  </sb-custom-modal>
</ng-template>


<sb-card>
  <div card-header classes="no-border">
    <h3>{{'lang.globals.trackerAssignment' | translate}}</h3>
  </div>
  <div card-body>
    <sb-comp-notice-box [type]="'danger'" *ngIf="rawData?.trackers?.length === 0 && externalTracker?.length === 0">
      {{'lang.trackerAssignment.noTracker' | translate}}
    </sb-comp-notice-box>
    <sb-comp-notice-box [type]="'warning'" *ngIf="externalTracker?.length > 0">
      <div>
        {{'lang.notice.trackerAssignment'|translate}}
      </div>
      <div class="d-flex">
        <div *ngFor="let tracker of externalTracker; index as i; last as last ">
          <sb-comp-link
            [permission]="permissionService.Permission.visitor_tracker_show"
            [link]="util.RoutingID.trackerDetails"
            [pathParams]="[{id: 'trackerID',value: tracker?.id}]"
            ngbTooltip="{{'lang.globals.details' | translate}}" container="body"
            [title]="'Tracker '+tracker?.id">
          </sb-comp-link>
          <span *ngIf="!last">
            ,&nbsp;
          </span>
        </div>
      </div>
    </sb-comp-notice-box>
    <div *ngIf="loading === false">
      <sb-sankey-chart #sankey (elementClick)="handleClick($event)"
                       [chartData]="sankeyData"></sb-sankey-chart>
    </div>
  </div>
</sb-card>
